import * as React from 'react';
import { IconCianLogo16, IconMetroMsk16, IconPin16, IconPinLine16, IconBuilder16 } from '@cian/ui-kit/icons';
import { ISuggestData, ISuggestGroup } from './types';

export const SUGGEST_CATEGORIES: ISuggestGroup[] = [
  {
    key: 'newbuildings',
    label: 'Жилые комплексы',
    icon: <IconCianLogo16 color="gray20_100" />,
  },
  {
    key: 'undergrounds',
    label: 'Метро',
    icon: <IconMetroMsk16 color="gray20_100" />,
  },
  {
    key: 'districts',
    label: 'Районы',
    icon: <IconPinLine16 color="gray20_100" />,
  },
  {
    key: 'builders',
    label: 'Застройщики',
    icon: <IconBuilder16 color="gray20_100" />,
  },
  {
    key: 'address',
    label: 'Адреса',
    icon: <IconPin16 color="gray20_100" />,
  },
];

export const EMPTY_SUGGESTIONS: ISuggestData = {
  address: [],
  builders: [],
  districts: [],
  newbuildings: [],
  undergrounds: [],
};
